// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               unknown
// source: qonto/identity_verification/verification/firstparty/v4/request_credentials.proto

/* oxlint-disable */
import {
  ApiEvidence,
  ApiProvider,
  apiProviderFromJSON,
  apiProviderToJSON,
  ApiStatus,
  apiStatusFromJSON,
  apiStatusToJSON,
} from "./identity_verification";

/** Request message for RequestCredentials. */
export interface ApiRequestCredentialsRequest {
  /** The ID of the identity verification to request credentials for (UUID format). */
  readonly id: string;
}

/** Response message for RequestCredentials. */
export interface ApiRequestCredentialsResponse {
  /** The ID of the identity verification (UUID format). */
  readonly identityVerificationId: string;
  /** The ID of the identity the verification belongs to (UUID format). */
  readonly identityId: string;
  /** The provider handling the identity verification. */
  readonly provider: ApiProvider;
  /** The current status of the identity verification. */
  readonly status: ApiStatus;
  /** The evidences required or collected for this identity verification. */
  readonly evidences: readonly ApiEvidence[];
  /** The provider-issued token used by the client SDK to start the verification flow. */
  readonly providerToken: string;
  /** The URL to redirect the user to for providers that use redirect-based flows. */
  readonly redirectUrl: string;
}

/** Error definitions for RequestCredentials. */
export interface ApiRequestCredentialsErrors {
}

/** Not found error codes. */
export const ApiRequestCredentialsErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND - Identity verification with the given ID was not found. */
  NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND: "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND",
} as const;

export type ApiRequestCredentialsErrorsNotFoundError =
  typeof ApiRequestCredentialsErrorsNotFoundError[keyof typeof ApiRequestCredentialsErrorsNotFoundError];

export namespace ApiRequestCredentialsErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND =
    typeof ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND;
}

export function apiRequestCredentialsErrorsNotFoundErrorFromJSON(
  object: any,
): ApiRequestCredentialsErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND":
      return ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND;
    default:
      return ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiRequestCredentialsErrorsNotFoundErrorToJSON(
  object: ApiRequestCredentialsErrorsNotFoundError,
): string {
  switch (object) {
    case ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiRequestCredentialsErrorsNotFoundError.NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND:
      return "NOT_FOUND_ERROR_IDENTITY_VERIFICATION_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Conflict error codes. */
export const ApiRequestCredentialsErrorsConflictError = {
  /** CONFLICT_ERROR_UNSPECIFIED - Unspecified conflict error. */
  CONFLICT_ERROR_UNSPECIFIED: "CONFLICT_ERROR_UNSPECIFIED",
  /** CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE - The identity verification is not in a retryable state. */
  CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE: "CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE",
  /** CONFLICT_ERROR_PROCESS_ALREADY_BOUND - The identity verification already has a provider process bound. */
  CONFLICT_ERROR_PROCESS_ALREADY_BOUND: "CONFLICT_ERROR_PROCESS_ALREADY_BOUND",
} as const;

export type ApiRequestCredentialsErrorsConflictError =
  typeof ApiRequestCredentialsErrorsConflictError[keyof typeof ApiRequestCredentialsErrorsConflictError];

export namespace ApiRequestCredentialsErrorsConflictError {
  export type CONFLICT_ERROR_UNSPECIFIED = typeof ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
  export type CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE =
    typeof ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE;
  export type CONFLICT_ERROR_PROCESS_ALREADY_BOUND =
    typeof ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_PROCESS_ALREADY_BOUND;
}

export function apiRequestCredentialsErrorsConflictErrorFromJSON(
  object: any,
): ApiRequestCredentialsErrorsConflictError {
  switch (object) {
    case 0:
    case "CONFLICT_ERROR_UNSPECIFIED":
      return ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
    case 1:
    case "CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE":
      return ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE;
    case 2:
    case "CONFLICT_ERROR_PROCESS_ALREADY_BOUND":
      return ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_PROCESS_ALREADY_BOUND;
    default:
      return ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED;
  }
}

export function apiRequestCredentialsErrorsConflictErrorToJSON(
  object: ApiRequestCredentialsErrorsConflictError,
): string {
  switch (object) {
    case ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_UNSPECIFIED:
      return "CONFLICT_ERROR_UNSPECIFIED";
    case ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE:
      return "CONFLICT_ERROR_IDENTITY_VERIFICATION_NOT_RETRYABLE";
    case ApiRequestCredentialsErrorsConflictError.CONFLICT_ERROR_PROCESS_ALREADY_BOUND:
      return "CONFLICT_ERROR_PROCESS_ALREADY_BOUND";
    default:
      return "CONFLICT_ERROR_UNSPECIFIED";
  }
}

/** Unprocessable entity error codes. */
export const ApiRequestCredentialsErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified unprocessable entity error. */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED - The identity verification's provider is not supported by this rpc. */
  UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED: "UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED",
  /** UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD - The membership's personal information required to start the provider process is missing or invalid. */
  UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD: "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD",
} as const;

export type ApiRequestCredentialsErrorsUnprocessableEntityError =
  typeof ApiRequestCredentialsErrorsUnprocessableEntityError[
    keyof typeof ApiRequestCredentialsErrorsUnprocessableEntityError
  ];

export namespace ApiRequestCredentialsErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED =
    typeof ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED;
  export type UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD =
    typeof ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD;
}

export function apiRequestCredentialsErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiRequestCredentialsErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED":
      return ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED;
    case 2:
    case "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD":
      return ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD;
    default:
      return ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiRequestCredentialsErrorsUnprocessableEntityErrorToJSON(
  object: ApiRequestCredentialsErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED:
      return "UNPROCESSABLE_ENTITY_ERROR_PROVIDER_NOT_SUPPORTED";
    case ApiRequestCredentialsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD:
      return "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

export const ApiRequestCredentialsRequest: MessageFns<ApiRequestCredentialsRequest> = {
  fromJSON(object: any): ApiRequestCredentialsRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiRequestCredentialsRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiRequestCredentialsResponse: MessageFns<ApiRequestCredentialsResponse> = {
  fromJSON(object: any): ApiRequestCredentialsResponse {
    return {
      identityVerificationId: isSet(object.identity_verification_id)
        ? globalThis.String(object.identity_verification_id)
        : "",
      identityId: isSet(object.identity_id) ? globalThis.String(object.identity_id) : "",
      provider: isSet(object.provider) ? apiProviderFromJSON(object.provider) : ApiProvider.PROVIDER_UNSPECIFIED,
      status: isSet(object.status) ? apiStatusFromJSON(object.status) : ApiStatus.STATUS_UNSPECIFIED,
      evidences: globalThis.Array.isArray(object?.evidences)
        ? object.evidences.map((e: any) => ApiEvidence.fromJSON(e))
        : [],
      providerToken: isSet(object.provider_token) ? globalThis.String(object.provider_token) : "",
      redirectUrl: isSet(object.redirect_url) ? globalThis.String(object.redirect_url) : "",
    };
  },

  toJSON(message: ApiRequestCredentialsResponse): unknown {
    const obj: any = {};
    if (message.identityVerificationId !== undefined && message.identityVerificationId !== null) {
      obj.identity_verification_id = message.identityVerificationId;
    }
    if (message.identityId !== undefined && message.identityId !== null) {
      obj.identity_id = message.identityId;
    }
    if (message.provider !== undefined && message.provider !== null) {
      obj.provider = apiProviderToJSON(message.provider);
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiStatusToJSON(message.status);
    }
    if (message.evidences?.length) {
      obj.evidences = message.evidences.map((e) => ApiEvidence.toJSON(e));
    }
    if (message.providerToken !== undefined && message.providerToken !== null) {
      obj.provider_token = message.providerToken;
    }
    if (message.redirectUrl !== undefined && message.redirectUrl !== null) {
      obj.redirect_url = message.redirectUrl;
    }
    return obj;
  },
};

export const ApiRequestCredentialsErrors: MessageFns<ApiRequestCredentialsErrors> = {
  fromJSON(_: any): ApiRequestCredentialsErrors {
    return {};
  },

  toJSON(_: ApiRequestCredentialsErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
